'use strict';

(function () {
  'use strict';

  angular.module('msTracker').component('msLowMoodIntervention', {
    bindings: {
      tags: '<',
      user: '<',
      navigateAction: '&'
    },
    templateUrl: 'tracker/templates/low-mood.html',
    controller: InterventionCtrl
  });

  InterventionCtrl.$inject = ['$log', '$q', 'httpSvc'];

  function InterventionCtrl($log, $q, httpSvc) {
    var vm = this,
        limit = 5,
        activityTypes = ['CORE', 'CORE_ARTICLE', 'ACTIVITY_PROGRAM', 'ACTIVITY_SERIES'];
    vm.title = 'InterventionCtrl';
    vm.showActivities = false;
    vm.go = function (activity) {
      vm.navigateAction({
        activity: activity
      });
    };
    vm.$onInit = init;

    function init() {
      vm.activities = [];
      if (!_.isArray(vm.tags)) {
        vm.tags = [vm.tags];
      }
      var promises = [];
      //in the case of interventions if we get more than one tag, we want to
      //submit them independently and union the responses on url, rather than batch submit
      //since the tag search api endpoint will do an intersection, not a union
      //when sending multiple tags.
      vm.tags.forEach(function (t) {
        var params = {
          tag: [t, 'session_survey:low_mood'],
          context: activityTypes,
          limit: limit
        };
        promises.push(httpSvc.get('/apiproxy/user/activities/search/tags/', {
          withCredentials: true,
          params: params
        }).then(function (res) {
          vm.activities = _.unionBy(vm.activities, res, 'url');
        }));
      });
      $q.all(promises).then(function () {
        return vm.showActivities = true;
      });
    }
  }
})();